import halbornIcon from "ui/assets/halborn.svg";

const auditData = [
  {
    link: "https://staderlabs.com/docs/Halborn/StaderLabs_Hedera_Stader_Protocol_v3_Smart_Contract_Security_Audit%20final%20.pdf",
    title: "Halborn",
    logo: halbornIcon,
  },
];

export { auditData };
